import React from 'react';
import { createPortal } from 'react-dom';
import { Upload, X, MapPin } from 'lucide-react';
import { MAX_HA, MIN_HA } from '../../lib/kmlImport';

export function KmlPolygonPicker({ candidates, truncatedCount, onSelect, onClose }) {
  if (typeof document === 'undefined') return null;

  return createPortal(
    <div className="fixed inset-0 z-[10001] flex items-end justify-center bg-black/50 p-4 sm:items-center">
      <div className="max-h-[85vh] w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b border-brand-dark/10 px-5 py-4">
          <div>
            <h3 className="font-display font-bold text-brand-dark">Elegí un polígono</h3>
            <p className="mt-1 text-xs text-brand-earth">
              Entre {MIN_HA} y {MAX_HA} ha · {candidates.length} opción(es)
              {truncatedCount > 0 && ` (+${truncatedCount} más en el archivo)`}
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-brand-earth hover:bg-brand-dark/5"
            aria-label="Cerrar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>

        <ul className="max-h-[50vh] overflow-y-auto p-3">
          {candidates.map((candidate) => (
            <li key={candidate.id}>
              <button
                type="button"
                onClick={() => onSelect(candidate)}
                className="mb-2 flex w-full items-center gap-3 rounded-xl border border-brand-dark/10 p-4 text-left transition hover:border-brand-accent hover:bg-brand-accent/5"
              >
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand-accent/15">
                  <MapPin className="h-5 w-5 text-brand-dark" />
                </div>
                <div className="min-w-0 flex-1">
                  <p className="truncate font-semibold text-brand-dark">{candidate.label}</p>
                  <p className="text-sm text-brand-accent">
                    {candidate.hectares.toFixed(1)} ha
                  </p>
                </div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>,
    document.body,
  );
}

export function KmlUploadButton({ onFileSelect, disabled, isLoading }) {
  const inputRef = React.useRef(null);

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept=".kml,.kmz,application/vnd.google-earth.kml+xml,application/vnd.google-earth.kmz"
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          if (file) onFileSelect(file);
          e.target.value = '';
        }}
      />
      <button
        type="button"
        disabled={disabled || isLoading}
        onClick={() => inputRef.current?.click()}
        className="map-control-button"
        title="Subir archivo KML o KMZ (máx. 50 MB)"
      >
        <Upload className="h-4 w-4" strokeWidth={2.5} />
        <span className="map-control-label">{isLoading ? 'Leyendo…' : 'Subir KML/KMZ'}</span>
      </button>
    </>
  );
}
